import { useEffect, useState } from 'react';
import { Layout, Menu, message, Skeleton, Space, Typography } from 'antd';
import { Link } from "react-router";
import logoBlue from "../../assets/logo_blu.png";
import { changeApplication, generateMenuIcon } from '../../utils/functions';
import { MacCommandOutlined, RightOutlined } from '@ant-design/icons';
import { menuLinks, notifyMessages } from '../../utils/constants';
import { useTranslation } from 'react-i18next';
import { useFullScreenLoader } from '../../context/fullScreenLoaderContext';
import { useUserAuth } from '../../context/UserContext';
import CommonServices from '../../services/commonServices';

const { Sider } = Layout;
const { Text } = Typography;

const SiderMenu = () => {
    const { t } = useTranslation();
    const { setLoading } = useFullScreenLoader();
    const { user, applications, activeApp, setActiveApp, selectedApp, activePage, setActivePage } = useUserAuth();
    const [collapsed, setCollapsed] = useState(false);
    const [menuList, setMenuList] = useState([]);
    const [applicationsMenu, setApplicationsMenu] = useState([]);

    useEffect(() => {
        if (user) { getMenus(user.id) };
    }, []);

    useEffect(() => {
        if (applications && applications.length >= 0) {
            getApplicationsMenu();
        }
    }, [applications, user, selectedApp]);

    const getMenus = async (userId: string) => {
        try {

            const respData = await CommonServices.getMenus(userId);
            if (respData.success) {
                const respDataObject: any = respData.responseObject.value;
                const data: any = respDataObject.menuDetails[0].menuData;
                if (!activePage) {
                    let dashboradMenu: any = data.find((item: any) => item.menuLink === menuLinks.dashboard);
                    if (!dashboradMenu) {
                        localStorage.setItem("activePage", dashboradMenu.menuID)
                    }
                    
                }
                generateMenu(data);
            }
            else {
                message.error(notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        } finally {
        }
    }

    const getApplicationsMenu = async () => {
        const label = (user?.lastSelectedApplicationName ?? selectedApp?.name ?? "-");
        const appMenu = {
            label: label,
            key: "178",
            icon: <MacCommandOutlined />,
            children: []
        };
        applications?.forEach((item: any) => {
            appMenu.children.push({ key: item.value, label: item.label, title: item.label }as never)
        });
        setApplicationsMenu(appMenu as any);
    }

    const generateMenu = async (menuData: any) => {
        let userMenu: any[] = [];
        menuData.map((item: any) => {
            let hasChildren = (item.menuItems && item.menuItems.length > 0);

            let menuItem: any = {
                label: (hasChildren ? <Text style={{ fontWeight: 500 }}>{item.menuDisplayName}</Text> : <Link to={{ pathname: item.menuLink as string }} style={{ fontWeight: 500 }}>{item.menuDisplayName}</Link>),
                key: item.menuID,
                icon: generateMenuIcon(item.menuLink),
                link: item.menuLink
            };

            if (hasChildren) {
                menuItem["children"] = [];
                item.menuItems.map((child: any) => {
                    let childItem: any = {};
                    childItem = {
                        label: <Link to={{ pathname: child.menuItemLink as string }}>{child.menuItemDisplayName}</Link>,
                        key: child.menuItemID,
                        icon: <RightOutlined />,
                        link: child.menuItemLink
                    }
                    menuItem.children.push(childItem);
                })
            }
            userMenu.push(menuItem);
        })
        setMenuList(userMenu as any);
    }

    const onMenuSelect = (item: any) => {
        localStorage.setItem("activePage", item.key);
        setActivePage(item.key);
    }

    const onAppMenuSelect = async (item: any) => {
        localStorage.setItem("activeApp", item.key);
        let dashboradMenu: any = menuList.find((item: any) => item.link === menuLinks.dashboard[0]);

        setActiveApp(item.key);
        setActivePage(dashboradMenu?.key);
        localStorage.setItem("activePage", dashboradMenu?.key);

        let payload = {
            applicationID: item.key,
            userID: user.id
        }
        setLoading(true);
        await changeApplication(payload);
        setLoading(false);

        window.location.replace("/");
    }

    return (
        <Sider className='sider' collapsible collapsed={collapsed} onCollapse={value => setCollapsed(value)}>
            <Space className="logo">
                <Link to={{ pathname: `/` }}><img src={logoBlue} alt="LOGO" /></Link>
            </Space>


            {(menuList && menuList.length > 0) && (
                <Menu
                    theme="light"
                    className='memus'
                    onSelect={(item) => onMenuSelect(item)}
                    selectedKeys={[activePage]}
                    mode="inline"
                    items={menuList}
                />
            )}

            {(menuList && menuList.length < 1) && (
                <Skeleton active />
            )}

            <Menu
                theme="light"
                className='applicationTypeMenu'
                style={{ marginTop: "auto" }}
                onSelect={(item) => onAppMenuSelect(item)}
                selectedKeys={[activeApp ?? selectedApp.id]}
                mode="inline"
                items={[applicationsMenu as any]}
            />
        </Sider>
    );
}

export default SiderMenu;